import { z } from 'zod';

// Schema (source of truth)
export const latLonSchema = z.object({
	latitude: z.number(),
	longitude: z.number(),
});

// Type (derived from schema)
export type ILatLon = z.infer<typeof latLonSchema>;
